import axios from 'axios'
import { getHeaders } from '@/tools/utils.js'

axios.defaults.baseURL = process.env.VUE_APP_API_URL

const prefix = '/params'

export default {

  async control (file) {
    const headers = await getHeaders()
    return axios.post(prefix + '/control', file, { headers })
  }
}
